module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-43.ed92ccd3.png";